import request from "../utils/request";
import SalesIDRetriever from "../utils/SalesIDRetriever";
import { getSessionId, getSystemSettings, getSpotlioSessionId, setTimestamp } from "../utils/SettingsRetriever";

import { store } from "../store/configureStore";

const baseParams = (parameters, extra = {}) => {
  let params = {
    ...parameters,
    id: getSystemSettings().id,
    sessionId: getSessionId(),
    salesId: SalesIDRetriever()
  }

  if(getSystemSettings().spotlioSession){
    params.uuid = getSpotlioSessionId()
  }
  
  if (getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.viewMode === "lines"){
    params.group = 0
  } else {
    params.group = 1
  }

  if(extra.group) params.group = extra.group;
  if(extra.bundle) params.bundle = extra.bundle;
  
  // always query with bundle relationship
  params.bundle = 1;

  return params;
}

const getStoreState = () => {
  let state = store.getState();
  return state.cart;
}

export const emptyCart = (extras) => {
  store.dispatch({type: "SET_CART_RESPONSE", value: null});
  store.dispatch({type: "SET_CART_STATUS", value: false});
  store.dispatch({type: "SET_DEPSCH_STATUS", value: false});
}

export const getItinerary = (extras) => {
  return new Promise((resolve, reject) => {
    const state = getStoreState();

    if (state.cart.queried && !extras.reload) {
      resolve(state.cart.response);
      return;
    }

    let params = baseParams({}, extras);

    request({
      url: getSystemSettings().api + "/cart",
      method: "POST",
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        setTimestamp(new Date().getTime())
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: true });
        store.dispatch({ type: "SET_CART_RESPONSE", value: res });
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
};

export const getDepositSchedule = (extras) => {
  return new Promise((resolve, reject) => {
    const state = getStoreState();
    if (state.depositSchedule.queried && !extras.reload) {
      resolve(state.depositSchedule.response);
    }

    let params = baseParams({}, {});

    request({
      url: getSystemSettings().api + "/inntopia/cart/depositSchedule",
      method: "POST",
      data: params
    })
      .then((data) => {
        if (data.status >= 200 && data.status <= 299) {
          const res = data.data;
          store.dispatch({ type: "SET_DEPSCH_STATUS", value: true });
          store.dispatch({ type: "SET_DEPSCH_RESPONSE", value: res });
          resolve(res);
        }
      })
      .catch(() => {
        reject(false);
      });
  });
}

export const add = (parameters) => {
  return new Promise((resolve, reject) => {
    let params = baseParams(parameters, {});

    request({
      url: getSystemSettings().api + '/inntopia/cart/add',
      method: 'POST',
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const addFlight = (parameters) => {
  return new Promise((resolve, reject) => {
    request({
      url: getSystemSettings().api + "/inntopia/flights/add",
      method: "POST",
      data: parameters
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(data.status);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const addPackage = (parameters) => {
  return new Promise((resolve, reject) => {
    let params = baseParams(parameters, {});

    request({
      url: getSystemSettings().api + '/inntopia/cart/addPackage',
      method: 'POST',
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const addBundle = (parameters) => {
  return new Promise((resolve, reject) => {
    let params = baseParams(parameters, {});

    request({
      url: getSystemSettings().api + '/inntopia/cart/addBundle',
      method: 'POST',
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const remove = (parameters) => {
  return new Promise((resolve, reject) => {
    let params = baseParams(parameters, {});

    request({
      url: getSystemSettings().api + '/inntopia/cart/remove',
      method: 'POST',
      data: params
  })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}